export default __webpack_public_path__ + "a8ccbcb444808bb77ffd953440e4d2f4.png";